export default __webpack_public_path__ + "static/media/LengthOfStay.4dd37ef0.svg";